var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5A822B39-2622-4DC7-92E8-EFEB19F29B55@1.00x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2.-Atoms",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table-Elements",
    transform: "translate(-469.000000, -454.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn/24/delivery/arrived",
    transform: "translate(469.000000, 454.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_status",
    strokeWidth: 1,
    fillRule: "evenodd",
    transform: "translate(3.000000, 3.000000)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle",
    fill: "#128845",
    fillRule: "evenodd",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3076923,19.6045673 L12.8269231,19.0528846 C13.1514423,18.6634615 13.546274,18.1388221 14.0114183,17.4789663 C14.4765625,16.8191106 14.9471154,16.1105769 15.4230769,15.3533654 C15.8990385,14.5961538 16.3046875,13.7848558 16.640024,12.9194712 C16.9753606,12.0540865 17.1430288,11.2860577 17.1430288,10.6153846 C17.1430288,9.27403846 16.672476,8.1328125 15.7313702,7.19170673 C14.7902644,6.25060096 13.6490385,5.78004808 12.3076923,5.78004808 C10.9663462,5.78004808 9.81971154,6.25600962 8.86778846,7.20793269 C7.9375,8.13822115 7.47235577,9.27403846 7.47235577,10.6153846 C7.47235577,11.2860577 7.64543269,12.0649038 7.99158654,12.9519231 C8.33774038,13.8389423 8.72175481,14.6340144 9.14362981,15.3371394 C9.56550481,16.0402644 10.0576923,16.765024 10.6201923,17.5114183 C11.1826923,18.2578125 11.5721154,18.7554087 11.7884615,19.0042067 C12.0048077,19.2530048 12.1778846,19.453125 12.3076923,19.6045673 L12.3076923,19.6045673 Z M12.3076923,12.3353365 C11.8317308,12.3353365 11.4206731,12.1730769 11.0745192,11.8485577 C10.75,11.5024038 10.5877404,11.0913462 10.5877404,10.6153846 C10.5877404,10.1394231 10.7554087,9.73377404 11.0907452,9.3984375 C11.4260817,9.06310096 11.8317308,8.89543269 12.3076923,8.89543269 C12.7836538,8.89543269 13.1893029,9.06310096 13.5246394,9.3984375 C13.859976,9.73377404 14.0276442,10.1394231 14.0276442,10.6153846 C14.0276442,11.0913462 13.859976,11.4969952 13.5246394,11.8323317 C13.1893029,12.1676683 12.7836538,12.3353365 12.3076923,12.3353365 Z",
    id: "\\uE0C8",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrived);
export default __webpack_public_path__ + "static/media/arrived.541fe62e78f398710494a893a56ed9f8.svg";
export { ForwardRef as ReactComponent };